import type { WebViewModalProps } from "@/ui/composed/media/webView/WebViewModal/types";

// WebViewModal not used on Web; only use cases are:
//  1) SafetyPlanSection for links (on web, open a new tab)
//  2) LoginForm for resetPasswordLink (on web, no LoginForm, redirect to auth0.com/login UniversalLoginpage)
// no-op stub here to ensure the native WebViewModal component is never pulled in anywhere
const WebViewModal = (_props: WebViewModalProps) => null;

export default WebViewModal;
